import React, { FC } from "react"
import ModuleContainer from "../moduleContainer"
import { Spinner } from "react-bootstrap"
import classes from "./PageSpinner.module.scss"

const PageSpinner: FC = () => {
  return (
    <ModuleContainer>
      <div className={classes.flexContainer}>
        <Spinner animation="border" variant="success" />
      </div>
    </ModuleContainer>
  )
}

export default PageSpinner
